import { Box, Image, Text } from '@wix/design-system'
import React, { memo } from 'react'

export const WixStudioSidePanelText = memo<{ text: string }>(({ text }) => (
  <Box gap="18px" align="center">
    <Box width="31px" height="31px" marginTop="3px">
      {!!text && (
        <Image
          transparent
          src="https://static.wixstatic.com/shapes/b9ec1f_3e4c113109084f7b9fad9f1456cdf6db.svg"
          width="100%"
          height="100%"
        />
      )}
    </Box>
    <Box flex="1" maxWidth={348}>
      <Text size="medium" weight="thin">
        {text}
      </Text>
    </Box>
  </Box>
))
